export const convertMonth = (month, isGenitive) => {
    if (month === 'January') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Январ${endLetter}`
    }
    if (month === 'February') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Феврал${endLetter}`
    }
    if (month === 'March') {
        let endLetter = ''
        if (isGenitive) {
            endLetter = 'а'
        }
        return `Март${endLetter}`
    }
    if (month === 'April') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Апрел${endLetter}`
    }
    if (month === 'May') {
        let endLetter = 'й'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Ма${endLetter}`
    }
    if (month === 'June') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Июн${endLetter}`
    }
    if (month === 'July') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Июл${endLetter}`
    }
    if (month === 'August') {
        let endLetter = ''
        if (isGenitive) {
            endLetter = 'а'
        }
        return `Август${endLetter}`
    }
    if (month === 'September') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Сентябр${endLetter}`
    }
    if (month === 'October') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Октябр${endLetter}`
    }
    if (month === 'November') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Ноябр${endLetter}`
    }
    if (month === 'December') {
        let endLetter = 'ь'
        if (isGenitive) {
            endLetter = 'я'
        }
        return `Декабр${endLetter}`
    }

    return month
}